const isArray = (val) => Array.isArray(val)

export default isArray
